import { Col } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MindmatchExternalResultLabeledScore, MindmatchExternalResultScore } from '../../../types';
import PolarAreaChartWithLabel from './PolarAreaChartWithLabel';
import Title from './Title';
import { findTwoLargestValuesIndex } from './Utils/findTwoLargestValuesIndex';

interface TestInterestsProps {
  interestScore?: MindmatchExternalResultScore;
}

const TestInterests: React.FC<TestInterestsProps> = ({ interestScore }) => {
  const { t } = useTranslation();

  const order = ['social', 'conventional', 'realist', 'investigative', 'entrepreneur', 'artistic'];

  const labels: string[] = [];
  const data: number[] = [];

  if (interestScore) {
    order.forEach((value) => {
      if (interestScore[value]) {
        const labeledScore = interestScore[value] as MindmatchExternalResultLabeledScore;
        labels.push(labeledScore.label);
        data.push(labeledScore.value);
      }
    });
  }

  const backgroundColor = ['#018B97', '#018B97', '#018B97', '#018B97', '#018B97', '#018B97'];
  const darkBlue = '#002529';

  const twoLargestValuesIndex = findTwoLargestValuesIndex(data);
  backgroundColor[twoLargestValuesIndex[0]] = darkBlue;
  backgroundColor[twoLargestValuesIndex[1]] = darkBlue;

  return (
    <Col>
      <Title
        title={t('Interesses profissionais')}
        tooltipText={t(
          'O teste de interesses é um teste que visa ajudar pessoas a identificar qual é o tipo de trabalho preferido. É possível entender melhor quais atividades fazem mais sentido para o candidato, de forma a aumentar sua satisfação, seu desempenho e sua qualidade de vida ao fazer algo que lhe seja prazeroso, o gráfico abaixo, estão listados os seis tipos de interesse, de forma que, quanto mais longe do centro do gráfico, maior o seu interesse por esse tipo e em destaque os dois maiores interesses.'
        )}
      />
      <PolarAreaChartWithLabel labels={labels} data={data} backgroundColor={backgroundColor} />
    </Col>
  );
};

export default TestInterests;
